import type React from 'react';
import {
  Alert as DsAlert,
  InfoContainer as DsInfoContainer,
  type AlertProps,
  type InfoContainerProps,
} from '@lmn/design-system';

// The design system types these two as React.VFC, dropped in @types/react 19, so skipLibCheck resolves them to any and their props go unchecked; import them from here instead.
export const Alert: React.FC<AlertProps> = DsAlert;
export const InfoContainer: React.FC<InfoContainerProps> = DsInfoContainer;
export type { AlertProps, InfoContainerProps };
